module.exports = __webpack_public_path__ + "img/features_img_penjualan.25457016.png";